import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchArticles = async (params = {}) => {
  const { data } = await axios.get(`${API}/articles`, { params });
  return data;
};

export const fetchArticle = async (slug) => {
  const { data } = await axios.get(`${API}/articles/${slug}`);
  return data;
};

export const fetchCategories = async () => {
  const { data } = await axios.get(`${API}/categories`);
  return data;
};

export const CATEGORY_LABELS = {
  sports: "Sports",
  entertainment: "Entertainment",
  culture: "Culture",
  featured: "Featured Stories",
};
